export const handleChangeInputRange = (e, id, action, values) => {
	const targetId = e.target.id;
	const value = e.target.value;

	if(!values[id]) values[id] = {};
	values[id][targetId] = value;

	action(values, id, targetId);
};


// WEBPACK FOOTER //
// src/helpers/lib/handleChangeInputRange.js